<template>
  <div class="brainsmap-container">
    <el-dialog v-if="showwmspop" :visible.sync="showwmspop" width="30%" center>
      <table class="brains-table2 saved-search-table" role="presentation" aria-describedby="wmsdata">
        <tbody>
          <tr>
            <td>{{ $t("ALLEGATO") }}</td>
            <td>{{ wmsdata.ALLEGATO }}</td>
          </tr>
          <tr>
            <td>{{ $t("COD_COMUNE") }}</td>
            <td>{{ wmsdata.COD_COMUNE }}</td>
          </tr>
          <tr>
            <td>{{ $t("DENOM") }}</td>
            <td>{{ wmsdata.DENOM }}</td>
          </tr>
          <tr>
            <td>{{ $t("FOGLIO") }}</td>
            <td>{{ wmsdata.FOGLIO }}</td>
          </tr>
          <tr>
            <td>{{ $t("NUM_PART") }}</td>
            <td>{{ wmsdata.NUM_PART }}</td>
          </tr>
          <tr>
            <td>{{ $t("SEZIONE") }}</td>
            <td>{{ wmsdata.SEZIONE }}</td>
          </tr>
          <tr>
            <td>{{ $t("SIGLA_PROV") }}</td>
            <td>{{ wmsdata.SIGLA_PROV }}</td>
          </tr>
          <tr>
            <td>{{ $t("SVILUPPO") }}</td>
            <td>{{ wmsdata.SVILUPPO }}</td>
          </tr>
          <tr>
            <td>{{ $t("TIPOLOGIA") }}</td>
            <td>{{ wmsdata.TIPOLOGIA }}</td>
          </tr>
        </tbody>
      </table>
    </el-dialog>
    <div id="viewDivwms" style="height: 100%" />
    <div v-if="loading" class="brains-map-loader" />
  </div>
</template>
<script>
import basemap from '@/components/mixins/wmsmap'
export default {
  name: 'BrainsMap',
  mixins: [basemap]
}
</script>

<style lang="scss">
.poly_container {
  width: 32px;
  margin-top: 8px;
  .esri-sketch__tool-section {
    display: flex;
    flex-direction: column;
  }
}
.portfolio-typo-legend {
  position: absolute;
  width: 200px;
  right: 5px;
  bottom: 5px;
  background-color: white;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
  padding: 15px;
  font-family: 'Montserrat-Regular',sans-serif;
  font-size: 13px;

  &--title {
    font-family: 'Montserrat-SemiBold',sans-serif;
    font-size: 14px;
  }

  &--row {
    display: flex;
    align-items: center;
  }
}

</style>

<style lang="scss" scoped>
.brainsmap-container {
  height: calc(100vh - 110px);
  width: 100%;
  position: relative;
}

div#viewDiv {
  padding: 0;
  margin: 0;
  width: auto;
  height: 100%;
}

.mapcontrols {
  position: absolute;
  top: 10px;
  left: 5px;
}

.el-collapse-item__arrow {
  display: none;
}

.legendcontrol {
  position: absolute;
  bottom: 100px;
  left: 15px;
}

.mapfilters_integrated {
  position: absolute;
  top: 35px;
  right: 10px;
}

.locationdetails {
  font-family: "Montserrat-Regular",sans-serif;
  font-size: 13px;
  display: flex;
  position: absolute;
  top: 0px;
  width: 100%;
  background-color: white;
  opacity: 0.6;
  padding: 7px;

  .pullright {
    margin-right: 0;
    margin-left: auto;
  }
}

.sub-title {
  font-family: "Montserrat-SemiBold",sans-serif;
}

.sub-title-legend {
  text-align: left;
  margin-left: 15px;
  font-weight: bold;
  color: rgb(90, 90, 90);
  margin-bottom: 7px;
  width: 100%;
}

.legendcoloritem {
  height: 25px;
  width: 25px;
  margin: 2px;
  margin-right: 7px;
  opacity: 0.7;
  border: 1px solid black;
}

.legenditemcontainer {
  display: inline-flex;
  transform: scale(0.9);
  align-items: center;
  color: rgb(102, 101, 101);
}

.filterlayerviewer {
  position: absolute;
  top: 5px;
  left: 5px;
  max-width: 250px;
  max-height: 400px;
  background-color: white;
}

.btn-legend-map {
  height: 32px;
  font-size: 12px;
  width: 32px;
  background-color: white;
  // border: 1px solid black;
  color: #6e6e6e;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);

  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: none !important;
  padding: 0 !important;
  margin: 0 !important;
  cursor: pointer;
  margin-top: 8px !important;
}

.poly_container .esri-sketch__tool-section {
  display: flex;
  flex-direction: column;
  // width: 32px;
  // background-color: white;
  // display: flex;
  // flex-direction: column;
  // text-align: center;
  // box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);

  // .poly_selector {
  //   padding: 3px;

  //   svg {
  //     padding: 2px;
  //     width: 20px;
  //     height: 20px;
  //     color: #1e3cff;
  //   }
  // }

  // .poly_selector:hover{
  //   background-color: lightgrey;
  //   cursor: pointer;
  // }

  // .poly_selector:active {
  //   background-color: #1e3cff;

  //   svg {
  //     color: white;
  //   }
  // }
}

.container-basemap-selector {
  display: flex;
  flex-direction: column;
  padding-left: 10px;
  /* font-size: 14px; */
  gap: 10px;
  justify-content: flex-start;

  .btn-selector-basemap--satellite,
  .btn-selector-basemap--topo {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 6px;
    cursor: pointer;
  }

  .basemap-active {
    color: #1e3cff;
  }
}

.container-legend {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  padding-left: 10px;
  padding-right: 5px;
  font-size: 12px;
}

.btn-gsv svg {
  font-size: 19px;
}

.iconclosebrains {
  position: absolute;
  right: 2px;
  top: 2px;
  font-size: 1.1em;
  font-weight: bold;
}
</style>
